import page404 from '@/components/page404'
const route = [
  {
    path: '*',
    redirect: {path: '/pages/404' },
  },
  {
    path:'/pages/404',
    meta:{title:'404'},
    component:page404
  }
];

export default route;



// WEBPACK FOOTER //
// ./src/router/page404.js